// `html, body, #root { height:100%; overflow-y:auto }` (index.css) — w CAŁEJ aplikacji to
// #root realnie scrolluje, nie window (window/body/documentElement są ograniczone do 100vh
// i same nigdy się nie przewijają). Dlatego samo `window.scrollTo` nie działa nigdzie w tym
// layoucie, a samo `el.scrollTop = 0` teleportuje zamiast animować.
//
// Wywołuj po pokazaniu komunikatu o zapisie na długich formularzach/stronach ustawień —
// banner renderuje się zwykle zaraz pod nagłówkiem strony, a przycisk zapisu bywa daleko
// pod nim, więc bez przewinięcia użytkownik nie widzi, czy zmiany w ogóle poszły.
export function scrollToTop() {
  if (typeof window === 'undefined') return;
  const smoothScroll = (el) => {
    if (!el) return;
    try {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      el.scrollTop = 0;
    }
  };
  const scroll = () => {
    smoothScroll(window);
    smoothScroll(document.scrollingElement || document.documentElement || document.body);
    smoothScroll(document.getElementById('root'));
  };
  requestAnimationFrame(scroll);
  setTimeout(scroll, 50);
}

export default scrollToTop;
